import React from 'react';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { WizardCard } from 'src/app/components/lib/wizard/card';

import { ApplicationMethodTypeId } from '../../../models';
import { useDiscountWizardStateContext } from '../../state';
import { ConfigureStepActions } from '../../state/configure';

export function DetailsCard() {
  const {
    configureStepState: { applicationMethod, discountCode, discountName },
    configureStepDispatch,
  } = useDiscountWizardStateContext();

  return (
    <WizardCard description='Give your discount a name and set a discount code (optional).' title='Discount details'>
      <FormSection>
        <Input
          label='Discount name:'
          labelPlacement='top'
          required
          value={discountName}
          onChange={({ target }) =>
            configureStepDispatch({ type: ConfigureStepActions.SET_DISCOUNT_NAME, payload: target.value })
          }
        />
        <Input
          label='Code:'
          labelPlacement='top'
          required={applicationMethod === ApplicationMethodTypeId.ByCode}
          value={discountCode}
          onChange={({ target }) =>
            configureStepDispatch({ type: ConfigureStepActions.SET_DISCOUNT_CODE, payload: target.value })
          }
        />
      </FormSection>
    </WizardCard>
  );
}
